import { useAccountData } from "../../../hooks/useAccountData";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import { FunnelContextArea, EventContextArea } from "../../funnel/types";
import { useGetNavigationContext } from "../../../hooks/useGetNavigationContext";
import { ComplexMenuItem } from "./ComplexMenuItem";
import { setFunnelModalConfig } from "../../funnel/FunnelModal.tsx";

export function GoldUpsellBanner({ onClick }: { onClick?: () => void }) {
  const account = useAccountData();

  const subscriptionValueProps =
    account?.account_links.subscription_value_props;

  const navigationContext = useGetNavigationContext({
    contextArea: EventContextArea.settings,
  });

  if (!subscriptionValueProps || typeof subscriptionValueProps !== "object") {
    return null;
  }

  const { headline, sub_head } = subscriptionValueProps;

  const handleSubscriptionSuccess = () => {
    setFunnelModalConfig({
      type: FUNNEL_TYPES.congrats,
      context: {
        navigationContext,
        modalContext: FunnelContextArea.settings,
      },
    });
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    const context = {
      navigationContext,
      modalContext: FunnelContextArea.settings,
    };
    setFunnelModalConfig({
      type: FUNNEL_TYPES.subscription,
      context,
      options: {
        locked: false,
        onSuccess: () => handleSubscriptionSuccess(),
      },
    });
  };

  return (
    <ComplexMenuItem
      onClick={handleClick}
      title={headline}
      subtitle={sub_head}
    />
  );
}
